import React from 'react';
import styled from 'react-emotion';
import ImageBox from 'components/image-box';
import Page from 'structure/page';
import bodyImage from './body.png';

const Paragraph = styled('p')({
  clear: 'both',
});

const List = styled('dl')();

const Heading = styled('dt')({
  fontWeight: 'bold',
});

const Content = styled('dd')({
  marginBottom: '1em',
  marginLeft: 0,
});

export const Measurements = (props) => (
  <Page title='Taking Measurements' {...props}>
    <Paragraph>Before we make your corset we will need the following measurements.</Paragraph>
    <ImageBox width="204px" height="400px" image={bodyImage} left />
    <List>
      <Heading>Bust</Heading>
      <Content>Your bust measurement at its widest</Content>
      <Heading>Under Bust</Heading>
      <Content>This is where your underwire sits</Content>
      <Heading>Waist</Heading>
      <Content>Your waist at the narrowest point</Content>
      <Heading>Hips</Heading>
      <Content>Your hips at their widest point</Content>
    </List>
    <Paragraph>It's best to take these measurements wearing only your bra and knickers. Make sure your bra fits well and is supportive. If you can, have someone else take your measurements as they will be more accurate.  Please remember that accurate measurements are vital to the fit and comfort of your corset.
    </Paragraph>
  </Page>);

export default Measurements;



// WEBPACK FOOTER //
// ./src/pages/measurements/measurements.js